import { IStoreState } from "../../../../reducers/types";

export const ancillaryExperimentsSelector = (state: IStoreState) =>
  state.flightAncillary.experiments;
